import {Address} from "./address";
import {AddressType} from "@app/shared";


export class OrgAddress {

  id: number;
  version?: number;
  addrName?: string;
  locationCode?: string;
  addrType?: AddressType;
  addrLn1: string;
  addrLn2: string;
  city: string;
  stateCode: string;
  postalCode: string;
  country: string;
  mainPhone?: string;
  faxPhone?: string;
  orgId: number;

  //Transient feilds
  taxExist?: boolean;

  constructor(id?: number) {
    if (id) {
      this.id = id;
    }
  }
}

